import type { ApplicationRiskMatch } from '../types';

interface ApplicationMatchResultsProps {
  matches: ApplicationRiskMatch[];
  loading: boolean;
  error: string | null;
  hasSelection: boolean;
}

export function ApplicationMatchResults({
  matches,
  loading,
  error,
  hasSelection,
}: ApplicationMatchResultsProps) {
  return (
    <section
      className="risk-library-card"
      aria-labelledby="application-match-results-title"
    >
      <div className="risk-library-actions">
        <div>
          <h2 id="application-match-results-title">Matching applications</h2>
          <p className="risk-library-muted">
            Results are grouped by application and include the exact matching
            matrix positions.
          </p>
        </div>
        <strong>
          {loading
            ? 'Searching…'
            : `${matches.length} application${
                matches.length === 1 ? '' : 's'
              } found`}
        </strong>
      </div>
      {error && <p className="risk-library-error">{error}</p>}
      {!loading && matches.length === 0 ? (
        <p className="risk-library-muted">
          {hasSelection
            ? 'No applications match the selected risk or matrix filters.'
            : 'Select at least one risk ID or matrix position to search applications.'}
        </p>
      ) : (
        <div className="risk-library-result-list">
          {matches.map(application => (
            <article className="risk-library-result" key={application.ban}>
              <div className="risk-library-actions">
                <strong>
                  {application.applicationName || 'Unnamed application'}
                </strong>
                <span className="risk-library-muted">{application.ban}</span>
              </div>
              <div className="risk-library-position-list">
                {application.positions.map(position => (
                  <span
                    className="risk-library-position"
                    key={`${position.riskCode}-${position.probabilityCode}-${position.severityCode}`}
                  >
                    <strong>{position.riskCode}</strong> at{' '}
                    {position.probabilityCode}-{position.severityCode}
                  </span>
                ))}
              </div>
            </article>
          ))}
        </div>
      )}
    </section>
  );
}
